import repository from "../Repository";

export default {
  async list(screenId) {
    return repository.post(
      `ope_auth_mst_info`,
      {},
      {
        headers: {
          s: screenId
        }
      }
    );
  },
  async create(screenId, payload) {
    return await repository.post(`ope_auth_mst_ope`, payload, {
      headers: {
        s: screenId
      }
    });
  },
  async update(screenId, payload) {
    return await repository.patch(`ope_auth_mst_ope`, payload, {
      headers: {
        s: screenId
      }
    });
  }
};
